import React, { useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const toolbarOptions = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'], // Formatting
  [{ list: 'ordered' }, { list: 'bullet' }], // Lists
  ['link', 'image'], // Links and images
  [{ align: [] }], // Alignment
  [{ color: [] }, { background: [] }], // Colors
  ['clean'], // Clear formatting
];

export function RichTextEditor({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const quillRef = useRef<ReactQuill | null>(null);

  useEffect(() => {
    // Access the Quill instance after mount
    const quillInstance = quillRef.current?.getEditor();

    if (quillInstance) {
      // Customize the toolbar's image handler
      const toolbar = quillInstance.getModule('toolbar');
      toolbar.addHandler('image', handleImageUpload);
    }
  }, []);

  const handleImageUpload = () => {
    const quill = quillRef.current?.getEditor(); // Access the Quill instance
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files ? input.files[0] : null;
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('diskPrefix', 'EditorUploads');
        formData.append('disk', 'public');
        try {
          const response = await fetch('/api/v1/file-entries', {
            method: 'POST',
            body: formData,
          });
          const data = await response.json();
          const range = quill?.getSelection();
          if (range) {
            quill?.insertEmbed(range.index, 'image', data.fileEntry.url);
          }
        } catch (error) {
          console.error('Image upload failed:', error);
        }
      }
    };
  };

  const modules = {
    toolbar: toolbarOptions, // Attach the toolbar options
  };

  return (
    <ReactQuill
      ref={quillRef}
      value={value}
      onChange={onChange}
      modules={modules}
      formats={[
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'list',
        'bullet',
        'link',
        'image',
        'align',
        'color',
        'background',
      ]}
    />
  );
}
